import {
  type CreatedSurveyFragment,
  type EditSurveySurveyFragment,
  EngagementUpdateSurveySettingsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { SurveyWizard } from 'modules/engagement_surveys/components/SurveyWizard'

interface Props {
  survey: EditSurveySurveyFragment
  onClose: () => void
  onSuccess: (survey: CreatedSurveyFragment) => void
}

export function EditSurveyWizard({ survey, onClose, onSuccess }: Props) {
  const [updateSurvey] = useMutation(EngagementUpdateSurveySettingsDocument, {
    extractorFn: (data) => data.surveysMutations.updateSurveysSurvey,
  })

  return (
    <SurveyWizard
      title={i18n.t('surveys.edit_survey_dialog.title')}
      initialValues={{
        title: survey.form.title,
        description: survey.form.description || '',
        anonymous: survey.form.anonymous,
        restrictedViewersEnabled: survey.restrictedViewersEnabled,
        editors: survey.editors.map((editor) => editor.employee),
        respondentStrategy: {
          strategy: survey.respondentStrategy.strategy,
          arguments: survey.respondentStrategy.arguments,
        },
      }}
      onClose={onClose}
      onSubmit={async (data) => {
        const result = await updateSurvey({
          variables: {
            surveyId: survey.id,
            title: data.title,
            anonymous: data.anonymous,
            description: data.description,
            respondentStrategy: data.respondentStrategy,
            restrictedViewersEnabled: data.restrictedViewersEnabled,
            editorIds: data.editors.map((editor) => editor.id),
          },
        })
        const handled = handleResult(result, () => null)

        if (handled.success && handled.data?.survey) {
          onSuccess(survey)
        }
      }}
    />
  )
}
